import { render, staticRenderFns } from "./SalesPerUnit.vue?vue&type=template&id=6403deb8&scoped=true"
import script from "./SalesPerUnit.vue?vue&type=script&lang=js"
export * from "./SalesPerUnit.vue?vue&type=script&lang=js"
import style0 from "./SalesPerUnit.vue?vue&type=style&index=0&id=6403deb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403deb8",
  null
  
)

export default component.exports